import { RouteInfo } from "common/routes/route-info.interface";

export const createRoutes = <T extends Record<string, RouteInfo>>(
  routes: T
): { [K in keyof T]: RouteInfo } => routes;
